import { render, staticRenderFns } from "./ProcessHandOffIcon.vue?vue&type=template&id=340e1da2"
import script from "./ProcessHandOffIcon.vue?vue&type=script&lang=js"
export * from "./ProcessHandOffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports